/**
 * Created by Administrador on 06/05/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('reportPassagesService',reportPassagesService);

    reportPassagesService.$inject = ['$http', 'CONFIG','messageService'];

    function reportPassagesService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-passenger-list';
        var urlAccountancy = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/accountancy';
        var urlAirportTax = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/dgac';

        var service = {
            getPostCheckInPassageAnnulment: getPostCheckInPassageAnnulment,
            getUnCheckPnr: getUnCheckPnr,
            getAirportTax: getAirportTax
        };

        return service;

        function getPostCheckInPassageAnnulment(fromDate, toDate){
            return $http.get(urlBase + '/annulled-list?fromDate=' + fromDate + '&toDate='+toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getUnCheckPnr(fromDate, toDate){
            return $http.get(urlAccountancy + '/uncheckedPnr?fromDate=' + fromDate + '&toDate='+toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getAirportTax(fromDate, toDate, airportId){
            return $http.get(urlAirportTax + '/airfare?fromDate=' + fromDate + '&toDate='+toDate + '&airportIds='+airportId)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
